import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/devices/_list/inventory/')({
  beforeLoad: () => {
    throw redirect({ to: '/devices/inventories', replace: true });
  },
});
